import React, {createRef, useEffect, useState} from 'react';
import styled from 'styled-components'
import useResponsive from "../../hooks/responsive";

export default function SubscribeModalCard({title, price, type, defaultActive = false}) {

    const [active, setActive] = useState(defaultActive)
    const [isMobile, maxWidth] = useResponsive();

    useEffect(() => {
        const l = (event) => {
            const t = event.detail

            setActive(t === type);
        }

        document.addEventListener('subcribe_modal_card_select', l)

        return () => {
            document.removeEventListener('subcribe_modal_card_select', l)
        }

    }, [])

    const select = () => {
        const event = new CustomEvent('subcribe_modal_card_select', { detail: type})
        document.dispatchEvent(event)
    }
    return(
        <Container isMobile={isMobile} active={active}
                   onClick={select}

        >
            <Title>{title}</Title>
            <Price active={active}>{price}</Price>
        </Container>
    )
}

const Container = styled.div`
    border: 1px solid ${props => props.active ? '#FA9F64' : 'white'};
    margin-top: ${props => props.isMobile ? '8px' : 0};
    padding: 16px;
    border-radius: 4px;
    cursor: pointer;
    color: ${props => props.active ? 'black' : 'white'};
    background-color: ${props => props.active ? '#FA9F64' : 'transparent'};

`

const Title = styled.div`
    text-align: center;
    font-weight: bold;
    font-size: 22px;
`

const Price = styled.div`
    padding-top: 8px;
    text-align: center;
    font-size: 26px;
    color:  ${props => props.active ? 'black' : '#FA9F64'};
`
